var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 2.16C8.8882 2.16 7.1602 3.888 7.1602 6C7.1602 8.112 8.8882 9.84 11.0002 9.84C13.1122 9.84 14.8402 8.112 14.8402 6C14.8402 3.888 13.1122 2.16 11.0002 2.16ZM11.0002 8.88C9.4162 8.88 8.1202 7.584 8.1202 6C8.1202 4.416 9.4162 3.12 11.0002 3.12C12.5842 3.12 13.8802 4.416 13.8802 6C13.8802 7.584 12.5842 8.88 11.0002 8.88ZM21.6562 5.664L19.5922 3.576C17.3122 1.272 14.2642 0 11.0002 0C7.7362 0 4.6882 1.272 2.4082 3.576L0.344195 5.664C0.152195 5.856 0.152195 6.144 0.344195 6.336L2.4082 8.424C4.6882 10.728 7.7362 12 11.0002 12C14.2642 12 17.3122 10.728 19.5922 8.424L21.6562 6.336C21.8482 6.144 21.8482 5.856 21.6562 5.664ZM18.9202 7.752C16.8082 9.864 14.0002 11.04 11.0002 11.04C8.0002 11.04 5.1922 9.864 3.0802 7.752L1.3522 6L3.0802 4.248C5.1922 2.136 8.0002 0.96 11.0002 0.96C14.0002 0.96 16.8082 2.136 18.9202 4.248L20.6482 6L18.9202 7.752Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.2e3b9b863d3fd5beb12285301f40874e.svg";
export { ForwardRef as ReactComponent };